import React from 'react';
import BaseQuestion from './BaseQuestion';

/**
 * Statement question component (just displays information)
 */
const StatementQuestion = ({
  question,
  questionIndex,
  onUpdate,
  onRemove,
  onMoveUp,
  onMoveDown,
  isFirst,
  isLast,
}) => {
  return (
    <BaseQuestion
      question={question}
      questionIndex={questionIndex}
      onUpdate={onUpdate}
      onRemove={onRemove}
      onMoveUp={onMoveUp}
      onMoveDown={onMoveDown}
      isFirst={isFirst}
      isLast={isLast}
      hideRequired={true}
      questionType="STATEMENT"
      questionTypeLabel="Statement"
      questionTypeIcon="ℹ️"
    >
      <div className="mt-3 p-3 bg-info bg-opacity-10 border border-info rounded">
        <div className="text-info">
          This is a statement - respondents will only see the title and description above.
        </div>
      </div>
    </BaseQuestion>
  );
};

export default StatementQuestion;
